Vue.component('ack-mobile-shop-filters', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-mobile-shop-filters',
	mounted() {
		let offcanvasEl = document.getElementById('mobile-shop-filters-offcanvas');
		this.offcanvas = new bootstrap.Offcanvas(offcanvasEl);
	},
	props: {
		filters: {
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
		},
	},
	computed: {
		//...Vuex.mapGetters('navBar', ['switchMobileDropdowns']),
		...Vuex.mapGetters('localization', ['countryCode']),
		isUSorCA() {
			return this.countryCode.toUpperCase() === 'US' || this.countryCode.toUpperCase() === 'CA';
		},
		conciergeLatam() {
			const latam = [
				'AR',
				'BO',
				'BR',
				'CL',
				'CO',
				'CR',
				'CU',
				'DO',
				'EC',
				'SV',
				'GT',
				'HN',
				'MX',
				'NI',
				'PA',
				'PY',
				'PE',
				'UY',
				'VE',
			];
			return latam.includes(this.countryCode.toUpperCase());
		},
		conciergeAustralia() {
			const australia = ['AU', 'NZ'];
			return australia.includes(this.countryCode.toUpperCase());
		},
	},
	data() {
		return {
			offcanvas: null,
			categories: [
				{
					image:
						window.ackShopifyFileUrl("sol_se_product.png"),
					alt: '3d_printers',
					description: '3D Printers',
				},
				{
					image:
						window.ackShopifyFileUrl("V4_Dual_Tanks.png"),
					alt: 'post_processing',
					description: 'Post Processing',
				},
				{
					image:
						window.ackShopifyFileUrl("V4-ALPHA_AI.png"),
					alt: 'software',
					description: 'Software',
				},
				{
					image:
						window.ackShopifyFileUrl("V4_Ackuretta_Concierge.png"),
					alt: 'services',
					description: 'Services',
					isUSorCA: true,
				},
				{
					image:
						window.ackShopifyFileUrl("V4_Resins_e172f900-6bed-48ec-b7fa-3f0d0f9f8cb5.png"),
					alt: 'resins',
					description: 'Resins',
				},
				{
					image: window.ackShopifyFileUrl("V4_BPs.png"),
					alt: 'Accessories',
					description: 'Accessories',
				},
				{
					image:
						window.ackShopifyFileUrl("SOL_Print_Screen_Pack_with_2.png"),
					alt: 'Spare Parts',
					description: 'Spare Parts',
				},
			],
			mobileMenuOpened: false,
			selectedCategory: null,
		};
	},
	methods: {
		//...Vuex.mapActions(['sayHi', 'someAction']),
		...Vuex.mapActions('shop', [
			'getProduct',
			'removeProduct',
			'removeCheckedFilter',
			'addCheckedFilter',
		]),
		showOffcanvasMenu() {
			this.mobileMenuOpened = !this.mobileMenuOpened;
		},

		showOffcanvas(alt_handle) {
			appLog.log(`on showOffcanvas with handle = ${alt_handle}`, LOG_TYPE.debug);
			this.selectedCategory = alt_handle;
			this.offcanvas.show();
		},
		hideOffcanvas() {
			appLog.log('on hideOffcanvas', LOG_TYPE.debug);
			this.selectedCategory = null;
			this.offcanvas.hide();
		},

		loadBundle(bundleTag) {
			this.$emit('load-bundle', bundleTag);
		},
	},
	beforeDestroy() {
		this.hideOffcanvas();
	},
	watch: {},
});
